/**
 * @requires variables.js
 * @requires ../../../../../../../node_modules/pensions-portals-fe/nnip/js/precompiled/plugins.js
 * @requires ../../../../../../../node_modules/pensions-portals-fe/nnip/js/nnip/menuNN.js
 * @requires ../../../../../../../node_modules/pensions-portals-fe/nnip/js/precompiled/frameworks.js
 * @requires ../../../../../../../node_modules/pensions-portals-fe/nnip/js/precompiled/vue-vuex.js
 * @requires ../../../../../../../node_modules/pensions-portals-fe/nnip/js/precompiled/highcharts.js
 * @requires ../../../../../../../node_modules/pensions-portals-fe/nnip/js/modules/pagingmodule.js
 * @requires ../../../../../../../node_modules/pensions-portals-fe/nnip/js/modules/formutil.js
 * @requires formvalidations.js
 * @requires ../../../../../../../node_modules/pensions-portals-fe/nnip/js/modules/formvalidationbindings.js
 * @requires ../../../../../../../node_modules/pensions-portals-fe/nnip/js/nnip/ajaxerrorhandling.js
 * @requires ../../../../../../../node_modules/pensions-portals-fe/nnip/js/nnip/retainPortfolio.js
 * @requires nnip/dutyofcare.js
 * @requires ../../../../../../../node_modules/pensions-portals-fe/nnip/js/nnip/firsttimelogin.js
 * @requires ../../../../../../../node_modules/pensions-portals-fe/nnip/js/nnip/globalFunctions.js
 * @requires nnip/wizard.js
 * @requires ../../../../../../../node_modules/pensions-portals-fe/nnip/js/nnip/workdetails.js
 * @requires ../../../../../../../node_modules/pensions-portals-fe/nnip/js/nnip/allocation.js
 * @requires ../../../../../../../node_modules/pensions-portals-fe/nnip/js/precompiled/parsley.js
*/

var globalFunctions = new nnip.classes.Globals();

(function () {
    $.fn.charReplacer = function (options) {
        var defaults = { replaceChar: '[^a-zA-Z 0-9 ?\n\\\\@,!._-]', replaceWith: '' };
        var settings = $.extend({}, defaults, options);
        $(this).on("keyup", function () {
            var val = $(this).val();
            if (val != "" || val != null) {
                if ((Array.isArray(settings.replaceChar) && Array.isArray(settings.replaceWith)) && (settings.replaceChar.length == settings.replaceWith.length)) {
                    for (var i = 0; i < settings.replaceChar.length; i++) {
                        val = val.replace(new RegExp(settings.replaceChar[i], "g"), settings.replaceWith[i]);
                    }
                } else {
                    val = val.replace(new RegExp(settings.replaceChar, "gm"), settings.replaceWith);
                }
            }
            $(this).val(val);
            val = '';
        });

        // IE eats up the change event when calling $(this).val() on keyup for some reason. Forcing change trigger on blur.
        $(this).on("blur", function () {
            $(this).trigger("change");
        });
    }

    $.fn.disableScroll = function () {
        window.oldScrollPos = $(window).scrollTop();

        $(window).on('scroll.scrolldisabler', function (event) {
            $(window).scrollTop(window.oldScrollPos);
            event.preventDefault();
        });
    };

    $.fn.enableScroll = function () {
        $(window).off('scroll.scrolldisabler');
    };

})(jQuery);

$(function () {

    // Run all init functions in init_functions array containing objects like {name: "myInitFunction", params ["myInitiParam1", "myInitParam2"]}
    for (var idx in init_functions) window[init_functions[idx].name].apply(this, init_functions[idx].params || []);

    // Initialize behaviours
    init_behaviour();
    //TODO: Remove this block and set autocomplete on the form fragment fields.
    $(document).on('focus', ':input', function () {
        $(this).attr('autocomplete', 'off');
    });

    //IE POLYFILL FOR ARRAY.FIND
    Array.prototype.find = Array.prototype.find || function (callback) {
        for (var i = 0; i < this.length; i++) {
            if (callback(this[i], i)) {
                return this[i];
            }
        }
    };


    /***************************************************************************
     * * * * * * * * * * * * * *
     *
     * NN MENU AFTER REBRANDING
     *  * * * * * * * * * * * * *
     */
    var slideSpeed = 200;
    var fadeSpeed = 200;
    var myAccount = $('.my-account');
    var element = $('.primary-navigation');

    var header = $('#top-inner');
    var headerHeight = header.height();

    if (headerHeight > 10) {

        $('.menu-list').hide();

        function rollItDown() {
            if (!($(this).hasClass('hovered')) && !$('body').hasClass('open')) {
                var menu = $(this).find('.menu-list');
                var slideHeight = menu.outerHeight();

                $('#top-bottom').hide();
                $('.hovered').not(this).removeClass('hovered');
                $(this).addClass('hovered');
                var headerHeightPlusSlider = headerHeight + slideHeight;
                header.stop().animate({
                    height: headerHeightPlusSlider,
                    'border-bottom-width': '0px'
                }, slideSpeed, 'linear');
                $('.main-visual').addClass('active');
                $('.shown').removeClass('shown').fadeOut(fadeSpeed);
                menu.fadeIn(slideSpeed).addClass('shown');
            }
        }
        function rollItUp() {
            if (!$('body').hasClass('open')) {
                var menu = $(this).find('.menu-list');

                $('.hovered').removeClass('hovered');
                $('.shown').fadeOut(fadeSpeed);
                if ($(this).parent().find('.shown').length) {
                    var headerHeightPlusBorder = headerHeight + 1;
                    header.stop().animate({
                        height: headerHeightPlusBorder,
                        'border-bottom-width': '1px'
                    }, slideSpeed, 'linear', function () {
                        header.removeAttr('style');
                        //header.css('style', '');

                    });
                }
                $('.main-visual').removeClass('active');
                $('.shown').removeClass('shown');
                $('#top-bottom').show();
            }
        }

        element.find('> ul > li.dropdown').on('mouseover focus', (rollItDown));
        element.find('> ul > li:not(.dropdown)').on('mouseover focus', (rollItUp));
        element.on('mouseleave blur', (rollItUp));
    }

    /* FAQ Search */
    function debouncer(func, timeout) {
        var timeoutID;
        timeout = timeout || 300;
        return function () {
            var scope = this, args = arguments;
            clearTimeout(timeoutID);
            timeoutID = setTimeout(function () {
                func.apply(scope, Array.prototype.slice.call(args));
            }, timeout);
        };
    }

    $('#notificationMessage').modal({ backdrop: 'static', keyboard: false });
    $('#notificationMessage').modal('show');
    $('#notificationMessage a.notificationAction').on('click', function () {
        $.when(setNotificationMessage('hideriskprofilemessage', 'true')).then(function (status) {
            if (status === "true") {
                $('#notificationMessage a.hidden').click();
            }
        });
    });
    $('#notificationMessage a.notificationActionCancel').on('click', function () {
        $.when(setNotificationMessage('hideriskprofilemessage', 'true')).then(function (status) {
            if (status === "true") {
                $('#notificationMessage a.hidden').click();
            }
        });
    });

    $('#searchinput').on('keyup', debouncer(function (e) {
        $("#searchinput").charReplacer();
        // Get all suspects
        $faqItems = $('#faqContainer .faqItem');
        $faqHeaders = $('.faqHeader');
        $faqBodies = $('#faqContainer .faqItem .accordion-body');
        $accordionToggles = $('.accordion-toggle');
        $faqPanelGroups = $('.panel-group');
        $openedItems = $('.in');

        var val = $(this).val();
        var options = { separateWordSearch: true, diacritics: true, debug: false };
        $(".faqElement").unmark().mark(val, options);

        if (val.length > 0) {
            var results = $('#faqContainer .faqItem').filter(function (i) {
                return $(this).text().toLowerCase().indexOf(val.toLowerCase()) >= 0;
            });

            if (results.length > 0) {

                var resultText = $(".faqSearch input[name='result']").val();
                var resultsText = $(".faqSearch input[name='results']").val();

                if (results.length == 1) {

                    $('#searchmessage').text(resultText.replace('@searchinput@', val));
                } else {
                    $('#searchmessage').text(resultsText.replace('@searchinput@', val).replace('@numresults@', results.length));
                }

                // Hide and close all items
                $faqItems.hide();
                $accordionToggles.addClass('collapsed');
                $openedItems.removeClass('in').css('height', '0px');
                $faqHeaders.hide();

                // Remove padding from the panel groups
                $faqPanelGroups.addClass('nopadding');

                // Show the results and the appropriate container
                results.show().closest('.accordion-body').addClass('in').css('height', 'auto');
                results.find('.accordion-toggle').css('height', 'auto');

                // Show the search again button
                $('.searchagain').show();
            } else {
                var noresultsText = $(".faqSearch input[name='noresults']").val();

                $('#searchmessage').text(noresultsText.replace('@searchinput@', val));
                // Revert to default with all all items closed
                $faqItems.show();
                $openedItems.removeClass('in').css('height', '0px');
                $accordionToggles.addClass('collapsed').css('height', 'auto');

                $faqHeaders.show();

                // Add padding back to the panel groups
                $faqPanelGroups.removeClass('nopadding');

                // Show the search again button
                $('.searchagain').show();
            }
            $('#searchmessage').removeClass("hidden");
        } else {
            $('#searchmessage').text('');
            // Revert to default with all all items closed
            $faqItems.show();
            $openedItems.removeClass('in').css('height', '0px');
            $accordionToggles.addClass('collapsed').css('height', 'auto');
            $faqHeaders.show();

            // Add padding back to the panel groups
            $faqPanelGroups.removeClass('nopadding');

            // Hide the search again button
            $('.searchagain').hide();

            $('#searchmessage').addClass("hidden");
        }
    }, 300));

    /* Disable default submit */
    $('#searchinput').closest('form').on('submit', function (e) {
        e.preventDefault();
    });

    /* Default hide the search again button */
    $('.searchagain').hide();

    /* Additional toggle mechanism for the FAQ accordion. */
    $("a.accordion-toggle").on("click", function () {
        var clickedHref = $(this).attr('href');

        // Collapse all other open arrows on this level
        var selector = 'h4 a.accordion-toggle:not(.collapsed)';
        if ($(this).parent().hasClass('faqHeader')) {
            var selector = 'a.accordion-toggle:not(.collapsed)';
        }
        $(selector).each(function () {
            if ($(this).attr('href') != clickedHref)
                $(this).addClass('collapsed');
        });

        // Collapse all other open items not in this group
        var faqElementId = $(this).closest('.faqElement').attr('id');
        $('.faqElement').each(function () {
            if ($(this).attr('id') != faqElementId) {
                $(this).find('.faqItem .accordion-body.in').removeClass('in').animate({
                    height: "1px"
                }, 100, function () {
                });
                if ($(this).find('h4').length <= 0) {
                    $(this).find('.accordion-body.collapse.in').removeClass('in').animate({
                        height: "1px"
                    }, 100, function () {
                    });
                }
            }

        });

        $(clickedHref).find('h4 a.accordion-toggle.collapsed').css('height', 'auto');

    });

    // GOTO Page functionality for News Overview Page
    $(".paging").on("submit", function (event) {

        var gotoPage = $("#topage").val();
        var itemsPerPage = $("#itemsPerPage").val();
        var lastPage = Math.ceil($("#topage").attr("data-totalPages"));

        // check if number is numeric
        var isNumeric = isNan(parseFloat(gotoPage));


        // If Text Entered is numeric
        if (isNumeric) {
            // If text is greater than max page , then set the goto page to last
            // page
            if (gotoPage > lastPage) {
                gotoPage = lastPage;
            }

            // If user enter 0 , page is redirected to first page
            if (gotoPage == 0) {
                gotoPage = 1;
            }

            // If Text Entered is non-numeric goto first page
        } else {
            gotoPage = 1;
        }

        var recursiveEncoded = $.param({
            begin: ((gotoPage - 1) * itemsPerPage)
        });
        $("form").attr('action', "?" + recursiveEncoded);

    });

    // Open close toggle feature
    $("tr.accountnr").on("click", function () {
        var clickedItem = $(this);
        var clickedItemDetails = $(this).next();

        clickedItem.addClass('current').toggleClass("open");
        clickedItemDetails.addClass('current').toggle().toggleClass("open");

        // Close other open items
        $("tr.accountnr.open:not(.current)").removeClass("open");

        // Close other open item details
        $("tr.more.open:not(.current)").hide().removeClass("open");

        clickedItem.removeClass("current");
        clickedItemDetails.removeClass("current");

    });

    // Disable caching of ajax calls and add csrf header
    var cookieSaltValue = cookieUtil.getCookie("csrfPreventionSaltCookie");
    $.ajaxSetup({
        cache: false,
        headers: { 'csrfPreventionSalt': cookieSaltValue }
    });

    // Password indicator
    initStrengthCalculator();

    // Form specific interactions
    initContactForm();
    initContactFormBehindLogin();
    initReportingForm();
    initPersonalQuestionForm();

    // Javascript to enable link to tab
    initTabs();


    // Button group behaviours
    bindButtonGroups();

    // Slider behaviours
    bindSavingsSlider();

    // Accordion fixes
    accordionFix();

    // Tooltip bind
    bindTooltips();

    // hide language toggle if needed
    hideLanguageToggle();

    /* * * * * * * * * * * * * * *
     *
     *  Delicious cookies
     *
     * * * * * * * * * * * * * * */

    $('.acceptedCookieUrl').on("click", function (e) {
        e.preventDefault();
        setCookie("UHAC", '1', 1, '/');
        $('#cookieContainer').slideUp("slow", function () {
            $('#cookieContainer').addClass('hiddenCookie');
            $('#cookieContainer').remove();
        });
    });


    if (!getCookie('UHAC')) {
        $('#cookieContainer').removeClass('hiddenCookie');

    }

    function setCookie(name, value, expires, path) {
        var d = new Date();
        d.setFullYear(d.getFullYear() + expires);
        document.cookie = name + "=" + escape(value) +
            ((expires) ? "; expires=" + d.toGMTString() : "") +
            ("; path=/");
    }

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

});

function init_behaviour() {
    if (behaviour.indexOf('fundOverview') >= 0) {
        FundOverviewModule.initialize();
        FundOverviewModule.addAccountFundOverview();
    }
    if (behaviour.indexOf('fundDetail') >= 0) {
        FundDetailModule.initialize();
        $('a[data-toggle="tab"]').on('shown', function (e) {
            var elementId = e.currentTarget.id;
            if (elementId == 'core_info_tab') FundDetailModule.showFundDetail();
            if (elementId == 'more_info_tab') FundDetailModule.showMoreInfo();
            if (elementId == 'return_tab') FundDetailModule.showReturnInfo();
        });
    }

    if (behaviour.indexOf('docDossier') >= 0) {
        docDossier.initialize();
        $('a[data-toggle="tab"]').on('shown', function (e) {
            var elementId = e.currentTarget.id;
            if (elementId == 'profileswitch') docDossier.showProfile();
            if (elementId == 'productswitch') docDossier.showInvestmentMethod();
            if (elementId == 'alert') docDossier.showAlerts();
            if (elementId == 'education') docDossier.showEducation();
        });
    }

    if (behaviour.indexOf('docReadingRoom') >= 0) {
        docReadingRoom.initialize();
    }
}

function initTabs() {
    // tab variable is safely escaped and placed in the htmlHeader.jspf.
    $('.nav.tabs-top a[href="#tab' + tab + '"]').tab('show');

}

function initContactFormBehindLogin() {
    var $step1form = $('.contact-form input[value=step1]').closest('form');
    var $step2form = $('.contact-form input[value=step2]').closest('form');
    var $step3form = $('.contact-form input[value=step3]').closest('form');

    /* STEP 1 */
    if ($step1form.length > 0) {
        // Disable radiobuttons, textarea and next button
        disable($step1form.find('textarea,#wmformfragment_email_phone input[type=radio],#verder .btn,#verder input[type=submit]'));
        var remainingcharacters = $("#textarea_feedback").html().split(':');
        var textAreaVal = $("#wmformfragment_uw_bericht").val();
        var textArea_max = 2000;
        var text_remaining = textArea_max - textAreaVal.length;
        $('#textarea_feedback').html(remainingcharacters[0] + ': ' + text_remaining);

        // Hide the 'I don't need an answer' option
        $('#wmformfragment_email_phone_none').parent().hide();

        // Put the emailaddress box in the correct place
        var $li = $('<li/>');
        var $emailbox = $step1form.find('#reply_email1');
        var $emailradio = $('#wmformfragment_email_phone_email');
        $li.append($emailbox);
        $emailradio.closest('li').after($li);

        // Bind the events to our validate function
        $step1form.find('input[type=text],textarea').on('keyup', function () {
            validateContactFormAfterLogin();
        });
        $step1form.find('input[name=u_hebt_een]').on('change', function () {
            validateContactFormAfterLogin();
        });
        $step1form.find('input[name=geboortedatum]').on('change', function () {
            validateContactFormAfterLogin();
        });
        $step1form.find('#wmformfragment_email_phone input[type=radio]').on('click', function () {
            validateContactFormAfterLogin();
        });

        // Trigger once
        validateContactFormAfterLogin();
    }

    /* STEP 2 */
    if ($step2form.length > 0) {

        // Put the telephone input box in the correct place
        var $telephoneinput = $('input[name=inputtelephone]');
        $telephoneinput.css({
            'width': 'auto',
            'margin-left': '12px'
        });
        var $telephoneerror = $('#inputtelephone .epError');
        $("#wmformfragment_telefoonnummer li:last-child").append($telephoneinput, $telephoneerror);

        var telephoneCount = 0;
        var telephoneVal = $('#wmformfragment_inputtelephone').val().trim();
        if (telephoneVal != undefined && telephoneVal != null) {
            var $step2form = $('.contact-form input[value=step2]').closest('form');
            telephoneCount = telephoneVal.length;
        }

        var filledFieldsCount = $step2form.find('input[type="text"]:not([name=inputtelephone])').filter(function () { return !!this.value; }).length;
        var $timeradio = $step2form.find('#wmformfragment_tijd input[type=radio]:checked').length;
        var $telephoneradio = $step2form.find('#wmformfragment_telefoonnummer input[type=radio]:checked').length;

        if (filledFieldsCount > 0 && $timeradio > 0 && $telephoneradio > 0) {
            enable($step2form.find('#bevestig .btn,#bevestig input[type=submit]'));
        } else {
            // Disable the next button
            disable($step2form.find('#bevestig .btn,#bevestig input[type=submit]'));
        }
        var $radiotelephone = $('#wmformfragment_telefoonnummer_telephone');
        if ($radiotelephone.is(':checked') && telephoneCount <= 0) {
            disable($step2form.find('#bevestig .btn,#bevestig input[type=submit]'));
        }

        var availableDate = getNextAvailableDate();
        if ($('input[name="datum"]').val() == "") {
            $('input[name="datum"]').val(availableDate);
        }

        findAvailTime();

        $step2form.find('input[type="text"][name="datum"]').on('keyup change', function () {
            findAvailTime();
        });

        $step2form.find('input[type="text"]').on('keyup change', function () {
            checkFilled();
        });

        $step2form.find('input[type=radio]').on('change', function () {
            checkFilled();
        });

        function checkFilled() {

            var telephoneCount = 0;
            var telephoneVal = $('#wmformfragment_inputtelephone').val().trim();
            if (telephoneVal != undefined && telephoneVal != null) {
                var $step2form = $('.contact-form input[value=step2]').closest('form');
                telephoneCount = telephoneVal.length;
            }

            var filledFieldsCount = $step2form.find('input[type="text"]:not([name=inputtelephone])').filter(function () { return !!this.value; }).length;
            var $timeradio = $step2form.find('#wmformfragment_tijd input[type=radio]:checked').length;
            var $telephoneradio = $step2form.find('#wmformfragment_telefoonnummer input[type=radio]:checked').length;

            var allFilled = false;
            // Counts
            var $radiotelephone = $('#wmformfragment_telefoonnummer_telephone');

            if (filledFieldsCount > 0 && $timeradio > 0 && $telephoneradio > 0) allFilled = true;

            if ($radiotelephone.is(':checked')) {
                $('#wmformfragment_inputtelephone').prop("disabled", false);
                $('#wmformfragment_inputtelephone').attr("placeholder", "");
            }

            if ($radiotelephone.is(':checked') && telephoneCount <= 0) allFilled = false;


            if (allFilled) {
                enable($step2form.find('#bevestig .btn,#bevestig input[type=submit]'));
            } else {
                disable($step2form.find('#bevestig .btn,#bevestig input[type=submit]'));
            }
        }
    }

    /* STEP 3 */
    if ($step3form.length > 0) {

    }
}

function validateContactFormAfterLogin() {
    // Elements
    var $step1form = $('.contact-form input[value=step1]').closest('form');
    var $emailbox = $step1form.find('#reply_email1');
    var $questionComplaintRemarkRadios = $step1form.find('#wmformfragment_u_hebt_een input[type=radio]');
    var $messageTextarea = $step1form.find('textarea');
    var $emailPhoneRadios = $step1form.find('#wmformfragment_email_phone input[type=radio]');
    var $emailRadio = $('#wmformfragment_email_phone_email');
    var $emailInput = $('input[name=uw_emailadres]');
    var $submitButton = $step1form.find('#verder .btn,#verder input[type=submit]');

    var selectedQCRradiosCount = $step1form.find('input[name=u_hebt_een]:checked').length;
    var selectedEPradiosCount = $step1form.find('input[name=email_phone]:checked').length;

    // Message Textarea
    if (selectedQCRradiosCount > 0) {
        enable($messageTextarea);

        if ($('input[name=u_hebt_een]:checked').val() == 'REMARK') {
            $('#wmformfragment_email_phone_none').parent().show();
        } else {
            $('#wmformfragment_email_phone_none').parent().hide();
        }

    } else {
        disable($messageTextarea);
    }

    // Email / Phone checkbox
    if (selectedQCRradiosCount > 0 && $messageTextarea.val().length > 0) {
        enable($emailPhoneRadios);
    } else {
        disable($emailPhoneRadios);
    }

    // Show / hide email area
    if (selectedQCRradiosCount > 0 && $messageTextarea.val().length > 0 && $emailRadio.is(':checked')) {
        $emailRadio.closest('ul.radio').parent().removeClass('span4').addClass('span8');
        $emailbox.removeClass('hidden');

        if ($('input[name=uw_emailadres]').val().length < 1) {
            disable($('#verder .btn,#verder input[type=submit]'));
        }
    } else {
        $emailRadio.closest('ul.radio').parent().removeClass('span8').addClass('span4');
        $step1form.find('#reply_email1').addClass('hidden');
        enable($('#verder .btn,#verder input[type=submit]'));
    }

    // Next button
    if (selectedQCRradiosCount > 0 && $messageTextarea.val().length > 0 && selectedEPradiosCount > 0) {

        // If the emailbox is visible, email must be filled out
        if ($emailRadio.is(':checked')) {
            if ($emailInput.val().length > 0) {
                enable($submitButton);
            } else {
                disable($submitButton);
            }
        } else {
            enable($submitButton);
        }

    } else {
        disable($submitButton);
    }
}



function initContactForm() {
    var $step1form = $('.contact-form input[value=wmstep_1]').closest('form');
    var $step2form = $('.contact-form input[value=wmstep_2]').closest('form');
    var $step3form = $('.contact-form input[value=wmstep_3]').closest('form');

    /* STEP 1 */
    if ($step1form.length > 0) {

        var remainingcharacters = $("#textarea_feedback").html().split(':');
        var textAreaVal = $("#wmformfragment_uw_bericht").val();
        var textArea_max = 2000;
        var text_remaining = textArea_max - textAreaVal.length;
        $('#textarea_feedback').html(remainingcharacters[0] + ': ' + text_remaining);

        // Disable radiobuttons, textarea and next button
        disable($step1form.find('textarea,input[type=radio],#verder .btn,#verder input[type=submit]'));

        // Hide the 'I don't need an answer' option
        $('#wmformfragment_email_phone_none').parent().hide();

        // Put the emailaddress box in the correct place
        var $li = $('<li/>');
        var $emailbox = $step1form.find('#reply_email1');
        var $emailradio = $('#wmformfragment_email_phone_email');
        $li.append($emailbox);
        $emailradio.closest('li').after($li);

        // Bind the events to our validate function
        $step1form.find('input[type=text],textarea').on('keyup', function () {
            validateContactForm();
        });
        $step1form.find('input[name=u_hebt_een]').on('change', function () {
            validateContactForm();
        });
        $step1form.find('input[name=geboortedatum]').on('change', function () {
            validateContactForm();
        });
        $step1form.find('#wmformfragment_email_phone input[type=radio]').on('click', function () {
            validateContactForm();
        });

        // Trigger once
        validateContactForm();


    }

    /* STEP 2 */
    if ($step2form.length > 0) {
        // Disable the next button
        disable($step2form.find('#bevestig .btn,#bevestig input[type=submit]'));

        var availableDate = getNextAvailableDate();
        if ($('input[name="datum"]').val() == "") {
            $('input[name="datum"]').val(availableDate);
        }

        findAvailTime();
        checkFilled();

        $step2form.find('input[type="text"][name="datum"]').on('keyup change', function () {
            findAvailTime();
        });

        $step2form.find('input[type="text"]').on('keyup change', function () {
            checkFilled();
        });

        $step2form.find('input[type=radio]').on('change', function () {
            checkFilled();
        });


        function checkFilled() {
            var allFilled = true;
            $step2form.find('input[type=text]').each(function () {
                if ($(this).val().length < 1 || ($('input[type=radio]:checked').length < 1))
                    allFilled = false;
            });

            if (allFilled) {
                enable($step2form.find('#bevestig .btn,#bevestig input[type=submit]'));
            } else {
                disable($step2form.find('#bevestig .btn,#bevestig input[type=submit]'));
            }
        }

    }

    /* STEP 3 */
    if ($step3form.length > 0) {

    }

}

function validateContactForm() {
    var filledFieldsBeforeActivating = 3;

    var $step1form = $('.contact-form input[value=wmstep_1]').closest('form');
    var $emailbox = $step1form.find('#reply_email1');

    // Elements
    var $questionComplaintRemarkRadios = $step1form.find('#wmformfragment_u_hebt_een input[type=radio]');
    var $messageTextarea = $step1form.find('textarea');
    var $emailPhoneRadios = $step1form.find('#wmformfragment_email_phone input[type=radio]');
    var $emailRadio = $('#wmformfragment_email_phone_email');
    var $hiddenEmailArea = $emailbox;
    var $emailInput = $('input[name=uw_emailadres]');
    var $submitButton = $step1form.find('#verder .btn,#verder input[type=submit]');

    // Counts
    var filledFieldsCount = $step1form.find('input[type="text"]:not([name=uw_emailadres])').filter(function () {
        return !!this.value;
    }).length;
    var selectedQCRradiosCount = $step1form.find('input[name=u_hebt_een]:checked').length;
    var selectedEPradiosCount = $step1form.find('input[name=email_phone]:checked').length;

    // Check if an element must be shown, hidden or disabled
    // Question / Complaint / Remark - checkbox
    if (filledFieldsCount > filledFieldsBeforeActivating) {
        enable($questionComplaintRemarkRadios);
    } else {
        disable($questionComplaintRemarkRadios);
    }

    // Message Textarea
    if (filledFieldsCount > filledFieldsBeforeActivating && selectedQCRradiosCount > 0) {
        enable($messageTextarea);

        // Show the complaints popup when applicable
        if ($('input[name=u_hebt_een]:checked').val() == 'REMARK') {
            $('#wmformfragment_email_phone_none').parent().show();
        } else {
            $('#wmformfragment_email_phone_none').parent().hide();
        }

    } else {
        disable($messageTextarea);
    }

    // Email / Phone checkbox
    if (filledFieldsCount > filledFieldsBeforeActivating && selectedQCRradiosCount > 0 && $messageTextarea.val().length > 0) {
        enable($emailPhoneRadios);
    } else {
        disable($emailPhoneRadios);
    }

    // Show / hide email area
    if (filledFieldsCount > filledFieldsBeforeActivating && selectedQCRradiosCount > 0 && $messageTextarea.val().length > 0 && $emailRadio.is(':checked')) {
        $emailRadio.closest('ul.radio').parent().removeClass('span4').addClass('span8');
        $emailbox.removeClass('hidden');

        if ($('input[name=uw_emailadres]').val().length < 1) {
            disable($('#verder .btn,#verder input[type=submit]'));
        }
    } else {
        $emailRadio.closest('ul.radio').parent().removeClass('span8').addClass('span4');
        $step1form.find('#reply_email1').addClass('hidden');

        enable($('#verder .btn,#verder input[type=submit]'));
    }

    // Next button
    if (filledFieldsCount > filledFieldsBeforeActivating && selectedQCRradiosCount > 0 && $messageTextarea.val().length > 0 && selectedEPradiosCount > 0) {

        // If the emailbox is visible, email must be filled out
        if ($emailRadio.is(':checked')) {
            if ($emailInput.val().length > 0) {
                enable($submitButton);
            } else {
                disable($submitButton);
            }
        } else {
            enable($submitButton);
        }

    } else {
        disable($submitButton);
    }
}

function getNextAvailableDate() {
    var dateObj = new Date();

    if ((dateObj.getDay() == 6) && ($('#wmformfragment_tijd li:gt(2):last input').val().split(/:|_/)[3] <= dateObj.getHours())) {
        dateObj.setDate(dateObj.getDate() + 2);
    } else if ((dateObj.getDay() != 6) && ($('#wmformfragment_tijd li:lt(3):last input').val().split(/:|_/)[3] <= dateObj.getHours())) {
        dateObj.setDate(dateObj.getDate() + 1);
    }

    var currentDay = dateObj.getDate();
    var currentMonth = dateObj.getMonth() + 1;
    currentMonth = currentMonth < 10 ? '0' + currentMonth : currentMonth;
    var currentYear = dateObj.getFullYear();

    return currentDay + '-' + currentMonth + '-' + currentYear;
}

function findAvailTime() {
    var availTimeInput = $('#wmformfragment_tijd').find("input");
    var selectedDate = $('#wmformfragment_datum').val();
    selectedDate = moment(selectedDate, "DD-MM-YYYY");
    var now = moment();

    if (selectedDate != "") {
        var dtObj = new Date(selectedDate);
        availTimeInput.each(function (index) {

            var dateObj = new Date();

            if (moment(selectedDate).isAfter(now, 'day')) {
                enable($(this));
            } else if (moment(selectedDate).isSame(now, 'day') && ($(this).attr('value').split(/:|_/)[3] <= dateObj.getHours())) {
                disable($(this));
                $(this).prop('checked', false);
            } else if (moment(selectedDate).isSame(now, 'day') && ($(this).attr('value').split(/:|_/)[3] > dateObj.getHours())) {
                enable($(this));
            } else {
                disable($(this));
                $(this).prop('checked', false);
            }

        });

        if (dtObj.getDay() == 6) {
            $('#wmformfragment_tijd li:lt(3)').hide();
            $('#wmformfragment_tijd li:lt(3) input').prop('checked', false);
            $('#wmformfragment_tijd li:gt(2)').show();
            if ($('#wmformfragment_tijd li:gt(2) input:not(:disabled)').length > 0) {
                $('#wmformfragment_tijd li:gt(2) input:not(:disabled):eq(0)').prop('checked', true);
            }
        } else {
            $('#wmformfragment_tijd li:gt(2)').hide();
            $('#wmformfragment_tijd li:gt(2) input').prop('checked', false);
            $('#wmformfragment_tijd li:lt(3)').show();
            if ($('#wmformfragment_tijd li:lt(3) input:not(:disabled)').length > 0) {
                $('#wmformfragment_tijd li:lt(3) input:not(:disabled):eq(0)').prop('checked', true);
            }
        }
    }

}

function initPersonalQuestionForm() {
    var $step1form = $('form input[value=changepersonalquestion_1]').closest('form');
    /* Personal Question edit step 1 */
    if ($step1form.length > 0) {
        var personalQuestionID = $("input[name=usersecurityquestionid]").val();
        var usersecurityquestion = $("input[name=usersecurityquestion]").val();
        var remainingcharacters = $("#textarea_feedback").html().split(':');
        var text_max = 100;
        var text_remaining = text_max - usersecurityquestion.length;

        if (personalQuestionID == 0) {
            $("#uw_vraag>div.hidden").removeClass("hidden").addClass("span4");
            $('#wmformfragment_uw_vraag').val(usersecurityquestion);
            $('#textarea_feedback').html(remainingcharacters[0] + ': ' + text_remaining);
        } else {
            $("#uw_vraag>div.span4").addClass("hidden").removeClass("span4");
            $(".epError").removeAttr("style");
            //$(".epError").css("style", "");

        }

        // Check if we should show or hide the text box
        $step1form.find('#wmformfragment_persoonlijke_vraag').on('change', function () {
            $(".epError").removeAttr("style");
            //$(".epError").css("style", "");
            var changeValue = this.value;
            $('#wmformfragment_uw_antwoord').val('');
            $('textarea#wmformfragment_uw_vraag').val('');
            if (changeValue != '' && changeValue == 0) {
                $("#uw_vraag>div.hidden").removeClass("hidden").addClass("span4");
            } else {
                $("#uw_vraag>div.span4").addClass("hidden").removeClass("span4");
            }
        });

        // Preselect correct vale based on security id
        $("#wmformfragment_persoonlijke_vraag > option").each(function () {
            var optionValue = this.value;
            if (optionValue == personalQuestionID) {
                $('select').val(optionValue);
            }
        });

    }
}

function initReportingForm() {
    var $step1form = $('form input[value=changereporting_1]').closest('form');

    /* Reporting edit step 1 */
    if ($step1form.length > 0) {

        // Put the email and postal boxes in the correct place
        var $emailli = $('<li/>');
        var $emailbox = $step1form.find('.formsectioncompound.email');
        var $emailradio = $('#wmformfragment_reporting_EMAIL');
        $emailli.append($emailbox);
        $emailradio.closest('li').after($emailli);

        var $postalli = $('<li/>');
        var $postalbox = $step1form.find('.formsectioncompound.postal');
        var $postalradio = $('#wmformfragment_reporting_POST');
        $postalli.append($postalbox);
        $postalradio.closest('li').after($postalli);

        // Sizing fix
        $step1form.find('input[name=reporting]').closest('ul').parent().removeClass('span4').addClass('span8');

        // Check if we should show or hide the email warning box
        var prefilledEmail = $step1form.find('input[name=uw_email_adres]').val();
        if (prefilledEmail.length > 0) {
            $step1form.find('#noemail').hide();
            $step1form.find('.formsectioncompound.postal .jq_gridcontentarea').show();
        } else {
            $step1form.find('#noemail').show();
            $step1form.find('.formsectioncompound.postal .jq_gridcontentarea').hide();
        }

        $step1form.find('input[name=reporting]').on('change', function () {
            if ($('input[name=reporting]:checked').length) {
                if ($('input[name=reporting]:checked').val() == 'EMAIL') {
                    $('.formsectioncompound.email').removeClass('hidden');
                } else {
                    $('.formsectioncompound.email').addClass('hidden');
                }

                if ($('input[name=reporting]:checked').val() == 'POST') {
                    $('.formsectioncompound.postal').removeClass('hidden');
                    // set to default
                    $('#wmformfragment_uw_email_adres').val($('#wmformfragment_uw_email_adres')[0].defaultValue);
                    $('#wmformfragment_herhaal_uw_email_adres').val($('#wmformfragment_uw_email_adres')[0].defaultValue);
                    $('.formsectioncompound.email').find('.epError').find("p").remove();
                    $('.formsectioncompound.email').find('.filled').find("p").remove();
                    $('.formsectioncompound.email').find('input').removeClass('parsley-error').addClass('parsley-success');

                } else {
                    $('.formsectioncompound.postal').addClass('hidden');
                }
            }
        });

        // Preselect correct radio based on correspondence method
        var correspondenceMethod = $step1form.find('input[name=correspondencemethod]').val();
        if (correspondenceMethod == 'POST') {
            $step1form.find('#wmformfragment_reporting_POST').prop("checked", true);
            $('.formsectioncompound.postal').removeClass('hidden');
        }

        if (correspondenceMethod == 'EMAIL') {
            $step1form.find('#wmformfragment_reporting_EMAIL').prop("checked", true);
            $('.formsectioncompound.email').removeClass('hidden');
        }

    }
}

function disable($element) {
    $element.attr("disabled", "disabled").addClass("disabled");
}

function enable($element) {
    $element.prop("disabled", false).removeClass("disabled");

}

/**
 * preferred language js
 */

var currentLanguage = $("input[name=wmfragment_3]").val();

$("#wmformfragment_voorkeurstaal_edit > option").each(function () {
    var optionValue = this.value;
    if (optionValue == currentLanguage) {
        $('select').val(optionValue);
    }
});

// Go to page filtering
function goToPageFilter() {

    // clear invalid input. Only digits allowed and only between 0 and the total number of pages.
    $(".gotopage").on("keyup", function () {

        var totalPages = $(this).attr("data-totalPages");
        var val = $(this).val();

        var intRegex = /^\d+$/;	// integer
        if (typeof val == 'undefined' || !intRegex.test(val) || val < 0 || val > +totalPages) {
            $(".gotopage").val('');
        }
    });

    // when enter is pressed, navigate to the page
    $(".gotopage").on("keypress", function (e) {
        if (e.which == 13) {
            e.preventDefault();

            var totalPages = $(this).attr("data-totalPages");
            var val = $(this).val();
            var pagingNumberToClick = $($(this)).closest("form").find("a[data-num=" + $(this).val() + "]");
            pagingNumberToClick[0].click();
        }
    });
}

function initToggle(accountNumber) {
    var tableId = "#" + accountNumber + "_transactions";
    $(tableId + " tr.enable-toggle").on("click", function (event) {
        event.preventDefault();
        var tr = $(this);
        tr.toggleClass("open");
        tr.next().toggle();
        $(tableId + " tr.enable-toggle.open").not(this).each(function (index, element) {
            var tr = $(this);
            tr.removeClass("open");
            tr.next().toggle();
        });
    });
}

function prependZero(inString) {
    var outString = inString;
    if (inString && inString.length === 1) {
        outString = '0' + inString;
    }
    return outString
}

//parse a date in dd-mm-yyyy format
function parseDateDayMonthYear(input) {
    var parts = input.split('-');
    return new Date(parts[2], parts[1] - 1, parts[0]); // Note: months are 0-based
}

//add a number or months to a date and return the result as Unix Epoch
function addMonthAndReturnAsEpoch(date, months) {
    return date.setMonth(date.getMonth() + months);
}

function subtractMonths(dataString, months) {
    var d = new Date(dataString.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"));
    d.setMonth(d.getMonth() - months);
    var day = d.getUTCDate().toString();
    var month = (d.getUTCMonth() + 1).toString();
    return prependZero(day) + "-" + prependZero(month) + "-" + d.getUTCFullYear();
}

// All needed Mustache Formatting functions.
function makeMustacheFormattingFunctions() {

    Mustache.Formatters = {
        "localePrice": function (nb, language) {
            if (!language) language = 'nl';
            var languageLocale = (language.toLowerCase() == 'nl') ? 'de-DE' : 'en-US';
            var number = parseFloat(nb);
            var formattedNumber = number.toLocaleString(languageLocale, {
                minimumFractionDigits: 4,
                maximumFractionDigits: 4
            });
            return formattedNumber;
        },
        "localeNumber": function (nb, language) {
            if (!language) language = 'nl';
            var languageLocale = (language.toLowerCase() == 'nl') ? 'de-DE' : 'en-US';
            // Workarround for safari 9 and lower. Added .toFixed because toLocalString is not working in older versions of safari.
            var number = parseFloat(nb).toFixed(2);
            var replaceCharacter = (language == 'nl') ? '.' : ',';
            var decimalSeperator = (language == 'nl') ? ',' : '.';
            number = number.replace(replaceCharacter, decimalSeperator);

            var formattedNumber = number.toLocaleString(languageLocale, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            return formattedNumber;
        },
        "localeUnits": function (nb, language) {
            if (!language) language = 'nl';
            var languageLocale = (language.toLowerCase() == 'nl') ? 'de-DE' : 'en-US';
            var number = parseFloat(nb);
            var formattedNumber = number.toLocaleString(languageLocale, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 6
            });
            return formattedNumber;
        },
        "oneDecimal": function (nb) {
            return globalFunctions.globalNumberToCurrency(nb, true, precision(nb));
            // return Number(nb).toFixed(1);
        },

        "convertToPercentage": function (nb) {
            return Number(nb) * 100;
        },
        "commaToPoint": function (nb) {
            return nb.toString().replace(/\,/g, '\.');
        },
        "currencySymbol": function (currency) {
            var currencyMap = {
                EUR: "\u20ac",
                GBP: "\u00A3",
                USD: "\u0024",
                JPY: "\u00A5"
            };
            return currencyMap[currency] || currency;
        },
        "date": function (dt) {
            var date = new Date(parseInt(dt));
            var day = prependZero(date.getUTCDate().toString());
            var month = prependZero((date.getUTCMonth() + 1).toString());

            return day + "-" + month + "-" + date.getUTCFullYear();
        }
    };

    var precision = function precision(number) {
        var match = ('' + number).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
        if (!match) { return 0; }
        return Math.max(
            0,
            // Number of digits right of decimal point.
            (match[1] ? match[1].length : 0)
            // Adjust for scientific notation.
            - (match[2] ? +match[2] : 0)
        );
    }
}

function stringToArray(elementDataString) {
    var fieldObject = {};
    var stringArray = elementDataString.split('|');
    if (stringArray && stringArray.length > 0) {
        for (i = 0; i < stringArray.length; i++) {
            fieldObject['field' + i] = stringArray[i];
        }
    }
    return fieldObject;
}

function initStrengthCalculator() {
    $('input.strengthIndicator').each(function () {
        var $passwordField = $(this);
        var $bar = $passwordField.prev();

        $passwordField.parent().addClass('wrapper');
        var messageBox = $('<div class="span4"><label class="strength" data-validate="strength" for="password"></label></div>');
        messageBox.insertAfter($passwordField.parent());

        $passwordField.on('keyup', function () {
            var value = $(this).val();
            var length = value.length;
            var label = $(this).parent().next().find('label');
            var $container = $(this).closest('.item.row-fluid');

            if (length > 0 && length < 8) {
                verdict = languageLabelShort;
                $bar.removeClass('strong').addClass('weak');
                $container.removeClass('passwordStrong').addClass('passwordWeak');
            } else if (testPassword(value) >= 13 && length > 60) {
                verdict = languageLabelLong;
                $bar.removeClass('strong').addClass('weak');
                $container.removeClass('passwordStrong').addClass('passwordWeak');
            } else {
                var score = testPassword(value);
                if (length > 0 && score < 25) {
                    verdict = languageLabelWeak;
                    $bar.removeClass('strong').addClass('weak');
                    $container.removeClass('passwordStrong').addClass('passwordWeak');
                } else {
                    if (length > 0) {
                        verdict = languageLabelStrong;
                        $bar.removeClass('weak').addClass('strong');
                        $container.removeClass('passwordWeak').addClass('passwordStrong');
                    } else {
                        $bar.removeClass('strong').removeClass('weak');
                        $container.removeClass('passwordStrong').addClass('passwordWeak');
                        verdict = '';
                    }
                }
            }

            $(label).html(verdict);

            if (length > 0) {
                $bar.width(length * 1.67 + '%');
            } else {
                $bar.width(0);
            }
        });
    });
}

function testPassword(passwd) {
    var intScore = 0;
    var requiredFields = 1;

    // PASSWORD LENGTH
    intScore += passwd.length;

    // [verified] at least one lower case letter
    if (passwd.match(/[a-z]/)) {
        intScore += 1;
    } else {
        requiredFields = 0
    }

    // [verified] at least one upper case letter
    if (passwd.match(/[A-Z]/)) {
        intScore += 5;
    } else {
        requiredFields = 0
    }

    // NUMBERS
    // [verified] at least one number
    if (passwd.match(/\d+/)) {
        intScore += 5;
    } else {
        requiredFields = 0
    }

    // [verified] at least three numbers
    if (passwd.match(/(.*[0-9].*[0-9].*[0-9])/)) {
        intScore += 5;
    }

    // SPECIAL CHAR
    // [verified] at least one special character

    if (passwd.match(/.*[@!#\$%\^\&\*\?_~]/)) {
        intScore += 5;
    }

    // [verified] at least two special characters
    if (passwd.match(/.*[@!#\$%\^\&\*\?_~].*[@!#\$%\^\&\*\?_~]/)) {
        intScore += 5;
    }

    // COMBOS
    // [verified] both upper and lower case
    if (passwd.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) {
        intScore += 3;
    }

    // [verified] both letters and numbers
    if (passwd.match(/([a-zA-Z])/) && passwd.match(/([0-9])/)) {
        intScore += 3;
    }

    // [verified] letters, numbers, and special characters
    if (passwd.match(/.*([a-zA-Z0-9][@!#\$%\^\&\*\?_~])/)) {
        intScore += 3;
    }

    var pattern = new RegExp(/(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\w@!?:\-\/\\.,+'_]{8,60})$/);
    var match = pattern.exec(passwd);
    if (match == null) {
        $('label[data-validate="notValid"]').addClass('show-warning');

        intScore = intScore * 0;

    } else {
        $('label[data-validate="notValid"]').removeClass('show-warning');

    }


    // Number of different characters
    var myArray = passwd.split('');
    var myNewString = "";

    for (i = 0; i < myArray.length; i++) {
        if (myNewString.indexOf(myArray[i]) == -1) {
            myNewString = myNewString + myArray[i];
        }
    }

    // If not at least 8 different characters are used, divide score by 2
    if ((myNewString.length / 8) < 1) {
        intScore = intScore - passwd.length;
    }

    return (intScore * requiredFields);
}

function getUrlParameter(parameterName) {
    var results = new RegExp('[\?&]' + parameterName + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
        return null;
    } else {
        return results[1] || 0;
    }
};

function integerToBooleanArray(number, arraySize) {
    var booleanArray = [];
    for (i = 0; i < arraySize; i++) {
        booleanArray.push({
            'active': ((i + 1) <= number)
        });
    }
    return booleanArray;
};

function sortArrayByProperty(arrayToSort, propertyName) {
    var arrayToSort = arrayToSort || [];

    function compare(a, b) {
        if (a[propertyName] < b[propertyName]) {
            return -1;
        } else if (a[propertyName] > b[propertyName]) {
            return 1;
        } else {
            return 0;
        }
    };
    return arrayToSort.sort(compare);
};

function sortArrayNumericByProperty(arrayToSort, propertyName) {
    var arrayToSort = arrayToSort || [];

    function compare(a, b) {
        return a[propertyName] - b[propertyName];
    }

    return arrayToSort.sort(compare);
};

function getMinOfArray(numArray) {
    return Math.min.apply(null, numArray);
}

function getMaxOfArray(numArray) {
    return Math.max.apply(null, numArray);
}

function bindButtonGroups() {
    $('.btn-group .btn').on("click", function () {
        var $buttongroupbuttons = $(this).closest('.btn-group').find('.btn');
        $buttongroupbuttons.removeClass('active');
        $(this).addClass('active');
    });
}

function bindSavingsSlider() {
    $("#savings").on("slide", function (slideEvt) {
        $(this).closest('fieldset').find('label span').text(': €' + slideEvt.value);
    });
}

// There is some serious nastyness going on with the bootstrap accordion behaviour and a lot of custom coding...
// This feels like putting more shit in the already steaming bucket...
function accordionFix() {
    $('.accordion-toggle').on("click", function () {
        $(this).addClass('immune');
        var accordionToggle = $(this).closest('.accordion').find('.accordion-toggle');
        accordionToggle.each(function () {
            if (!$(this).hasClass('immune')) $(this).removeClass('in');
        });
        $(this).toggleClass('in').removeClass('immune');
    });
}

function bindTooltips() {
    $('.iconInfo').tooltip({
        trigger: 'hover',
        html: true,
        container: 'body'
    });
}

function hideLanguageToggle() {
    var wmStepId = getWmStepId();
    if (hideToggle(wmStepId)) {
        var languageToggle = getLanguageToggle();
        if (languageToggle) languageToggle.css('visibility', 'hidden');
    }
}

function getWmStepId() {
    // do not get from url params to avoid nasty xss-injections
    var wmStepId = $("input.csfw_stepId[type='hidden']").val();
    return (wmStepId && wmStepId.length > 0) ? wmStepId : null;
}

// Hide toggle if step id is present and contains a number > 1
function hideToggle(wmStepId) {
    var hideToggle = false;
    if (wmStepId) {
        var numberPattern = /\d+/g;
        var numbers = wmStepId.match(numberPattern);
        hideToggle = (numbers && numbers[0] != 1);
    }
    return hideToggle;
}

function getLanguageToggle() {
    return $('#nav').find('.language');
}

function isAuthorized(name, type, id) {

    var dfd = $.Deferred();
    var authUrl = '/web/nniprestserviceservlet/isAuthorized';
    var authorizationData = new Object();
    authorizationData.serviceMethodName = name;
    authorizationData.contextType = type;
    authorizationData.contextId = id;

    $.ajax({
        type: "POST",
        url: authUrl,
        data: JSON.stringify(authorizationData),
        contentType: "application/json;",
        success: function (data) {
            dfd.resolve(data);
        },
        error: function (data, errMsg) {
            dfd.reject("false");
        }
    });
    return dfd.promise();
}

function checkAuthorization(method, type, id, element) {
    $.when(isAuthorized(method, type, id)).then(
        function (status) {
            if (status === "true") {
                $(element).show();
            } else {
                $(element).remove();
            }
        },
        function (status) {
            $(element).hide();
        }
    );
};

function setNotificationMessage(notification, value) {
    var dfd = $.Deferred();

    $.ajax({
        url: '/web/nniprestserviceservlet/notificationMessages/' + notification + '/' + value,
        type: 'POST',
        data: null,
        success: function (data) {
            dfd.resolve("true");
        },
        error: function (data) {
            dfd.reject("false");
        }
    });

    return dfd.promise();
};

var guid = function () {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return '@@' + s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}